import React from 'react';
export const Switch = ({
  checked,
  onCheckedChange,
  className = '',
  ...props
}) => {
  return <button role="switch" aria-checked={checked} onClick={() => onCheckedChange(!checked)} className={`relative inline-flex h-5 w-10 items-center rounded-full ${checked ? 'bg-blue-600' : 'bg-gray-200'} ${className}`} {...props} data-id="element-680">
      <span className={`${checked ? 'translate-x-5' : 'translate-x-1'} inline-block h-4 w-4 transform rounded-full bg-white transition`} data-id="element-681" />
    </button>;
};